// Dependencies
import React, { Component } from 'react'
// Externals
import Field from './Field'
import TextAreaField from './textareaField'
import ContactButton from './contactMeButton'

const contactStyles = {
    width: "90%",
    maxWidth: "50em",
    margin: "20px auto",
    border: "1px solid #ddd",
    borderRadius: "5px",
    padding: "10px"
  };

class Form extends Component {
    constructor(props) {
        super(props);
        this.state = {
            name: '',
            email: '',
            message: '',
            formIncomplete: true
        }
        this.updateField = this.updateField.bind(this)
        this.validateEmail = this.validateEmail.bind(this)
    }

    updateField(field, value) {
        this.setState({ [field]: value })
        if([field]== 'email') {
            this.validateEmail(value)
        }
    }
    validateEmail(value) {
        //todo validate email
        if (value.length > 0) {
            this.setState({ formIncomplete: false })
            //this.forceUpdate()
        }
        else {
            this.setState({ formIncomplete: true })
        }

    }

    render() {
        return (
            <div style={contactStyles}>
            <div>
                <Field
                    label="Name"
                    onChange={(event) => this.updateField('name', event.target.value)}
                    value={this.state.name}
                />
                <Field
                    label="Email"
                    onChange={(event) => this.updateField('email', event.target.value)}
                    value={this.state.email}
                />
                <TextAreaField
                    label="Message"
                    onChange={(event) => this.updateField('message', event.target.value)}
                    textarea={true}
                    value={this.state.message}
                />
            </div>
            <div style={{textAlign: "center", padding: "1em"}}>
                <ContactButton
                    formValues={this.state}
                />
            </div>
            </div>

        )
    }
}
export default Form;




// WEBPACK FOOTER //
// ./src/components/contactForm/Form.jsx